import { Check } from "lucide-react";

export default function SubmissionSuccessModal({
  open = true,
  onClose,
  success,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      {/* Modal */}
      <div className="relative w-full max-w-3xl rounded-2xl bg-[#FFF9F3] p-8 shadow-xl">
        {/* Header */}
        <h2 className="text-center text-xl font-bold text-black font-inter">
          {success
            ? "Professional Information Submitted Successfully!"
            : "Professional Information Submitted Failed!"}
        </h2>
        <p className="mt-1 text-center text-md text-gray-600 font-inter ">
          {success
            ? "We’re now verifying your documents. You will be notified once the review is complete."
            : "We couldn’t complete your submission due to a temporary issue ."}
        </p>

        {/* Card */}
        <div className="relative mt-8 rounded-2xl bg-white p-4 shadow-lg">
          {/* Success Icon */}
          <div
            className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full ${
              success ? "bg-green-100" : "bg-red-100"
            }`}
          >
            <img
              src={success ? "/greenTick.png" : "/fail.png"}
              alt="tick"
              className="h-7 w-7"
            />
          </div>

          {/* Title */}
          <h3
            className={`mt-4 text-center text-xl font-inter font-bold ${
              success ? "text-[#119206]" : "text-[#D00023]"
            }`}
          >
            {success ? "Submission Complete!" : "Submission Failed!"}
          </h3>
          <p className="mt-1 font-inter text-center text-sm text-[#333333]">
            Your work information has been successfully submitted on{" "}
            <span className="font-semibold">December 8, 2024</span>.
          </p>

          {/* Progress Wrapper */}
          <div className="relative mt-6">
            {/* Connecting Line (behind icons) */}
            <div className="absolute left-1/2 top-3 z-0 h-[4px] w-[60%] -translate-x-1/2 bg-[#F2E6F2]" />

            {/* Progress */}
            <div className="relative z-10 flex items-center justify-between gap-1">
              {["Work History", "Passport Details", "Travel History"].map(
                (label) => (
                  <div
                    key={label}
                    className="flex flex-1 flex-col items-center gap-1"
                  >
                    <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#572575]">
                      <Check className="h-4 w-4 text-white" strokeWidth={3} />
                    </div>
                    <p className="mt-2 text-xs font-medium text-black font-inter">
                      {label}
                    </p>
                  </div>
                )
              )}
            </div>
          </div>

          {/* Connecting Line */}
          <div className="absolute left-1/2 top-[175px] z-1 h-[4px] w-[60%] -translate-x-1/2 bg-[#F2E6F2]" />
        </div>

        {/* Button */}
        <div className="mt-8 flex justify-center">
          <button
            onClick={onClose}
            className="rounded-lg bg-[#572575] px-10 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-[#4a1f63]"
          >
            Explore Application
          </button>
        </div>
      </div>
    </div>
  );
}
